import $ from 'jquery/src/jquery';
import SiteNavMobile from "./site-nav-mobile";
import SiteHeader from "./site-header";

export default () => {
    const nodeSelectors = {
        mobileHeader: '[js-smooth-anchor="mobile-header"]',
    }

    function init() {
        if (!$('a[href^="#"]').length) {
            return
        }

        initAnchor()
    }

    function initAnchor() {
        $(document).on('click', 'a', function (event) {
            let url = $(this).attr('href');

            if( url.indexOf('#') >= 0 ) {
                let hash = url.substring(url.indexOf('#'));

                if( $(hash).length ) {
                    event.preventDefault()
                    let target = $(hash).offset().top
                    let headerHeight = $(SiteHeader().nodeSelectors.container).height()

                    if( $(nodeSelectors.mobileHeader).is(':visible') ) {
                        // if mobile header is visible set offset
                        target-= parseInt($(nodeSelectors.mobileHeader).outerHeight())
                    }

                    $("html, body").animate({ scrollTop: target - headerHeight }, "slow");

                    if( $(SiteNavMobile().nodeSelectors.container).is(':visible') ) {
                        SiteNavMobile().close()
                    }
                }
            }
        });
    }

    return Object.freeze({
        init,
    })
}